import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_INVENTORY_DETAIL_UPDATE } from "../apiRoutes";
import { removeEmptyFields } from "@/lib/utils";

export interface UpdateSchoolInventoryDetailPayload {
  schoolId: string; // used only for URL
  isTvIncluded?: boolean;
  is3DPrinterIncluded?: boolean;
  isPaintingIncluded?: boolean;
  isElectricalIncluded?: boolean;
  isStorageCabinetsIncluded?: boolean;
  isTeachersTableIncluded?: boolean;
  isPodiumIncluded?: boolean;
  isTabletsIncluded?: boolean;
  isChairsIncluded?: boolean;
  infrastructureNotes?: string | null;
  curriculumNotes?: string | null;
  otherNotes?: string | null;
}

export interface UpdateSchoolInventoryDetailResponse {
  status?: number;
  error?: boolean;
  message?: string;
  data?: any;
}

export const useUpdateSchoolInventoryDetailMutation = (
  options?: { onSuccess?: () => void }
) => {
  return useMutation({
    mutationFn: async (payload: UpdateSchoolInventoryDetailPayload) => {
      // ✅ Extract schoolId from payload for URL
      const { schoolId, ...body } = payload;

      // ✅ Send PUT request with schoolId in URL only, not in body
      const response = await axiosAuth.put<UpdateSchoolInventoryDetailResponse>(
        `${SCHOOL_INVENTORY_DETAIL_UPDATE}${schoolId}/`,
        removeEmptyFields(body)
      );

      return response.data;
    },
    onSuccess: () => {
      toast.success("Inventory details updated successfully");
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message ||
        error?.response?.data?.message ||
        "Failed to update inventory details";
      toast.error(message);
    },
  });
};
